export default __webpack_public_path__ + "static/media/directional-sign.6ca80213.svg";